/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, {useRef, useEffect} from "react";
import {useGLTF, useAnimations} from "@react-three/drei";

export default function Model({...props}) {
  const group = useRef();
  const {nodes, materials, animations} = useGLTF("/RubberTube/tubeRubber2.glb");
  const {actions} = useAnimations(animations, group);
  useEffect(() => {
    actions.Animation8.play();
    actions.Animation8.repetitions = 1;
    actions.Animation8.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh
          name="rubber2"
          geometry={nodes.rubber2.geometry}
          material={materials.rubber}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/RubberTube/tubeRubber2.glb");
